import {useDispatch, useSelector} from 'react-redux';

import LanguageSelectPopup from '@/components/LanguageSelect/components/LanguageSelectPopup/LanguageSelectPopup';
import ModalTypes from '@/consts/app/modalTypes';
import {
    CompleteTaskPopup,
    EarnBadgePopup,
    ExpiringBadgePopup,
    NewBadgePopup,
    NextTaskPopup,
} from '@/containers/Modals/components/Loyalty';
import {selectGlobalModals} from '@/state/selectors/modal';

import AgeGateDeniedPopup from './components/AgeGateDeniedPopup';
import AutoDeliveryStatusInactiveDetailsPopupSwitcher from './components/AutoDeliveryStatusInactiveDetailsPopupSwitcher';
import AutoDeliveryStatusNoneDetailsPopupSwitcher from './components/AutoDeliveryStatusNoneDetailsPopupSwitcher';
import BrowserNotCompatiblePopup from './components/BrowserNotCompatiblePopup';
import ConnectionCancellationPopup from './components/ConnectionCancellationPopup';
import ConnectionSelectionPopup from './components/ConnectionSelectionPopup';
import ConsumerFeedbackGatheringPopup from './components/ConsumerFeedbackGatheringPopup/ConsumerFeedbackGatheringPopup';
import DeviceRegistrationErrorPopup from './components/DeviceRegistrationErrorPopup/DeviceRegistrationErrorPopup';
import EnableNotificationModal from './components/EnableNotificationModal/EnableNotificationModal';
import EnableNotificationReminderModal from './components/EnableNotificationReminderModal/EnableNotificationReminderModal';
import FirmwareAvailablePopup from './components/FirmwareAvailablePopup/FirmwareAvailablePopup';
import HolderRegistrationPopup from './components/HolderRegistrationPopup';
import LeviaLearnMorePopup from './components/Levia/LeviaLearnMorePopup';
import MaintenancePopup from './components/MaintenancePopup';
import QuickOrderPopup from './components/QuickOrderPopup/QuickOrderPopup';
import ResetNotificationPermissionsModal from './components/ResetNotificationPermissionsModal/ResetNotificationPermissionsModal';

const MODAL_COMPONENTS = {
    [ModalTypes.LEVIA_LEAR_MORE]: LeviaLearnMorePopup,
    [ModalTypes.FIRMWARE_AVAILABLE]: FirmwareAvailablePopup,
    [ModalTypes.BROWSER_NOT_COMPATIBLE]: BrowserNotCompatiblePopup,
    [ModalTypes.CONSUMER_FEEDBACK_GATHERING]: ConsumerFeedbackGatheringPopup,
    [ModalTypes.LANGUAGE_SELECT]: LanguageSelectPopup,
    [ModalTypes.MAINTENANCE]: MaintenancePopup,
    [ModalTypes.ENABLE_NOTIFICATION]: EnableNotificationModal,
    [ModalTypes.ENABLE_NOTIFICATION_REMINDER]: EnableNotificationReminderModal,
    [ModalTypes.RESET_NOTIFICATION_PERMISSIONS]: ResetNotificationPermissionsModal,
    [ModalTypes.AUTO_DELIVERY_STATUS_NONE_DETAILS]: AutoDeliveryStatusNoneDetailsPopupSwitcher,
    [ModalTypes.AUTO_DELIVERY_STATUS_INACTIVE_DETAILS]: AutoDeliveryStatusInactiveDetailsPopupSwitcher,
    [ModalTypes.QUICK_ORDER]: QuickOrderPopup,
    [ModalTypes.CONNECTION_SELECTION]: ConnectionSelectionPopup,
    [ModalTypes.CONNECTION_CANCELLATION]: ConnectionCancellationPopup,
    [ModalTypes.HOLDER_REGISTRATION]: HolderRegistrationPopup,
    [ModalTypes.DEVICE_REGISTRATION_ERROR]: DeviceRegistrationErrorPopup,
    [ModalTypes.EARN_BADGE]: EarnBadgePopup,
    [ModalTypes.COMPLETE_JOURNEY_LEVEL_TASK]: CompleteTaskPopup,
    [ModalTypes.NEXT_JOURNEY_LEVEL_TASK]: NextTaskPopup,
    [ModalTypes.NEW_BADGE]: NewBadgePopup,
    [ModalTypes.EXPIRING_BADGE]: ExpiringBadgePopup,
    [ModalTypes.AGE_GATE_DENIED]: AgeGateDeniedPopup,
};

const ModalsRoot = () => {
    const modals = useSelector(selectGlobalModals);

    if (!modals.length) return null;

    const alwaysDisplayModals = modals.filter((m) => m.alwaysDisplay);
    const modalsSorted = [...modals].sort((a, b) => b.order - a.order);
    const curModal = modalsSorted[modalsSorted.length - 1];

    return (
        <>
            <CurrentModal curModal={curModal} />
            {alwaysDisplayModals.map((modal) => {
                const {modalType, modalProps} = modal;
                const ComponentModal = MODAL_COMPONENTS[modalType];

                return <ComponentModal key={modalType} {...modalProps} modalType={modalType} />;
            })}
        </>
    );
};

const CurrentModal = ({curModal}) => {
    const dispatch = useDispatch();

    if (!curModal) return null;

    const {modalType, modalProps, alwaysDisplay} = curModal;

    if (alwaysDisplay) return null;

    const SpecificModal = MODAL_COMPONENTS[modalType];

    if (!SpecificModal) return null;

    return <SpecificModal key={modalType} {...modalProps} modalType={modalType} dispatch={dispatch} />;
};

export default ModalsRoot;
